import { render, staticRenderFns } from "./EventDetailsAttachments.vue?vue&type=template&id=56ca6543&scoped=true&"
import script from "./EventDetailsAttachments.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsAttachments.vue?vue&type=style&index=0&id=56ca6543&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca6543",
  null
  
)

export default component.exports